// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".el-table__row.row-not-covered > td {\n  background-color: rgb(245, 145, 145) !important;\n}", ""]);
// Exports
module.exports = exports;
